import { render } from "./CartModal.vue?vue&type=template&id=2bf19042"
import script from "./CartModal.vue?vue&type=script&lang=js"
export * from "./CartModal.vue?vue&type=script&lang=js"

import "./CartModal.vue?vue&type=style&index=0&id=2bf19042&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__